import { TableProps, Tag } from "antd";
import dayjs from "dayjs";

const defineStatusColor = (status: string) => {
  switch (status) {
    case "checked":
      return "green";
    case "deleted":
      return "red";
    case "null":
      return "gray";

    default:
      return "gray";
  }
};

const defineStatusText = (status: string) => {
  switch (status) {
    case "checked":
      return "Aprovado";
    case "deleted":
      return "Deletado";
    case "null":
      return "Sem Status";

    default:
      return "Sem Status";
  }
};

export const columns: TableProps<any>["columns"] = [
  {
    title: "Criado em",
    dataIndex: "date_created",
    key: "date_created",
    render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
  },
  {
    title: "Data da Postagem",
    key: "date",
    dataIndex: "date",
    render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
  },
  {
    title: "Id do Objetivo",
    key: "smart_goal_id",
    dataIndex: "smart_goal_id",
  },
  {
    title: "Id da Persona",
    key: "persona_id",
    dataIndex: "persona_id",
  },
  {
    title: "Status",
    key: "status",
    dataIndex: "status",
    render: (_, { status }) => (
      <Tag color={defineStatusColor(status)}>
        {defineStatusText(status).toUpperCase()}
      </Tag>
    ),
  },
];
